module.exports = __webpack_public_path__ + "img/logo-black.17c7027f.jpg";